/*
 * @Author: your name
 * @Date: 2021-07-23 13:40:42
 * @LastEditTime: 2021-07-30 18:13:23
 * @LastEditors: xiaona.wang
 * @Description: In User Settings Edit
 * @FilePath: \scim-edm-web\src\store\modules\menuTabs.js
 */
const getDefaultState = () => ({
  menuTabs: [],
  menuActived: ""
});

const state = getDefaultState();

const mutations = {
  SET_MENU_TAB: (state, data) => {
    state.menuTabs = data;
  },
  ADD_MENU_TAB: (state, data) => {
    state.menuTabs.push(data);
  },
  DELETE_MENU_TAB: (state, name) => {
    const index = state.menuTabs.findIndex(item => item.name === name) || -1;
    if (index >= 0) {
      state.menuTabs.splice(index, 1);
    }
  },
  UPDATE_MENU_ACTIVED: (state, data) => {
    state.menuActived = data;
  },
  ADD_FIRST_TAB: (state, data) => {
    state.menuTabs.unshift(data);
  }
};

const actions = {
  addMenuTab({ commit, state }, data) {
    // 去重
    const tabIndex = state.menuTabs.findIndex(o => o.name === data.name);
    if (tabIndex === -1) {
      commit("ADD_MENU_TAB", { ...data, closable: true, delete: false });
      commit("UPDATE_MENU_ACTIVED", data.name);
    } else {
      // 更新缓存内容
      state.menuTabs[tabIndex] = {
        ...state.menuTabs[tabIndex],
        cacheView: data.cacheView,
        path: data.path,
        params: data.params,
        query: data.query,
        meta: data.meta
      };
      const tabItem = state.menuTabs[tabIndex];
      commit("UPDATE_MENU_ACTIVED", tabItem.name);
    }
  },
  deleteMenuTab({ commit, state }, data) {
    commit("DELETE_MENU_TAB", data);
  },
  setMenuTab({ commit, state }, data) {
    commit("SET_MENU_TAB", data);
  },
  updateMenuActived({ commit, state }, data) {
    commit("UPDATE_MENU_ACTIVED", data);
  },
  initMenuTab({ commit, state }) {
    // 判断state中是否存在Home页，没有，自动在第一个添加上
    const isExistHome = state.menuTabs.some(o => o.name === "dashboard");
    if (!isExistHome) {
      commit("ADD_FIRST_TAB", {
        name: "dashboard",
        title: "dashboard",
        path: "/dashboard",
        meta: { title: "dashboard", icon: "home" },
        query: {},
        closable: false
      });
    }
  }

};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
